<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">

          <header>
            <figure class="no-radius">
              <img :src="$iconFolder + 'options.svg'"/>
            </figure>
            <div>
                            <span class="breadcrumb">
                                Product <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
              <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>

            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
            </div>
          </header>

          <main>

             <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
              <tab name="Information">

                <fieldset>
                  <h3>Détail</h3>
                  <p class="headline"></p>

                  <form-text :label="'Nom'" v-model="resource.name"></form-text>

                  <hr>

                  <h3>Options à choix</h3>
                  <p class="headline"></p>

                  <form-select  v-model="selection" :options="attributes" v-if="selection || attributes" :callback="addAttributeToRoot"></form-select>

                  <draggable-option v-model="optionObject" key="root" :labels="attributeLabels" :attributes="attributes" v-if="attributeLabels"></draggable-option>

                </fieldset>


                <!--
                <br><br><br><br>

                <p v-if="!jsonValid" style="font-weight: bold; padding-bottom: 10px; color: #ba2766;">The given JSON string is not valid</p>
                <form-text :label="'Nom'" v-model="resource.name"></form-text>
                <form-code
                  label="Behavior"
                  v-model="optionObjectJson"
                  language="JavaScript" :required="true"></form-code>
                  -->

              </tab>
            </tabs>

          </main>
          <footer>
          </footer>
        </article>

      </div>
    </div>
  </transition>
</template>
<script>

import AttributeService from '../../config/attribute/AttributeService.js';
import ProductOptionService from './ProductOptionService.js';
import Edit from '../../../layouts/Edit.vue';
import draggableOption from './Option.vue';

export default {
  extends: Edit,
  components: {
    'draggableOption': draggableOption
  },
  data () {
    return {
      optionObjectJson: "",
      optionObject:[],
      attributes: [],
      attributeLabels: null,
      selection: null,
      resource: {
      },
      jsonString: '',
      jsonObject: {},
      isLoading: false,
      jsonValid: true
    }
  },
  mounted: function(){
    AttributeService.allForProducts().then(response => {
      this.attributes = []
      this.isLoading = false

      this.attributeLabels = {}

      for(let item of response.data){
        console.log(item);
        if( item.parent_id == null ){
          this.attributes.push(item);
        }

        this.attributeLabels[item.id] = item.name;
        for(let value of item.values){
          this.attributeLabels[item.id + '.' + value.id] = value.name;
        }

      }

      console.log("attributeLabels", this.attributeLabels)

    })
  },
  watch: {
    optionObject: {
      handler: function(newVal, oldVal) {
        this.updateTree()
      },
      deep: true
    },
    optionObjectJson: function(newValue) {
      let newJsonValue;
      try {
        newJsonValue = JSON.parse(newValue);
        this.jsonValid = true;
      } catch (e) {
        this.jsonValid = false;
        console.log(e);
      }
      this.optionObject = newJsonValue;
      this.resource.behavior_json = this.optionObject;
    }
  },
  methods:{
    resourceLoaded: function(){
      this.jsonString = JSON.stringify(this.resource.behavior_json, null, 2);
      if (!this.jsonString) {
        this.jsonString = '[{}]';
      }
      this.jsonObject = this.resource.behavior_json;
      this.optionObject = this.resource.behavior_json || [];

      this.treeData = {
        children:  this.optionObject
      }
      this.initialize()
    },
    getResource: function(){
      return ProductOptionService
    },
    updateTree: function()
    {
      this.optionObjectJson = JSON.stringify(this.optionObject, null, 2);
      this.$forceUpdate()
    },
    addAttributeToValue: function(item)
    {

        let node = this.addAttribute(this.selection)
        if( item && node )
        {
          item.children.push(node);
          this.updateTree();
        }

    },
    addAttributeToRoot: function(item)
    {

      if( item && item.id )
      {

        let exists = this.optionObject.filter(function (o) {
          return o.id == item.id;
        }).length > 0;

        if( exists ){
          alert("Cet attribut existe figure déjà dans votre élément !")
          return false;
        }

        let node = this.addAttribute(item)
        this.optionObject.push(node);
        this.updateTree();
      }

    },
    addAttribute: function(item)
    {

      console.log('addAttribute', item)

      if( item && item.id )
      {
        //this.selection = null;
        console.log('addAttribute', item);

        let values = [];
        for(let value of item.values){
          if( item.parent_id == null ){
            values.push({
              id: value.id,
              slug: item.id + '.' + value.slug,
              label: value.name,
              price: '+0',
              children: []
            });
          }
        }
        return {
          id: item.id,
          slug: item.id,
          label: item.name,
          required: false,
          values: values
        };
      }

      return null;

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/modules/shop/option/Edit.vue